module.exports = __webpack_public_path__ + "img/develop@2x.3cd65e03.jpg";